import { useCallback } from 'react'

import { Button, Icon, Modal } from '@circlefin/components'
import { useModal } from '@circlefin/modal-router'
import { TransWithLink } from '@shared/components/common'
import useTranslation from 'next-translate/useTranslation'

export const CrossCurrencySignSuccessMsa: React.FC = () => {
  const { t } = useTranslation('developer')
  const modal = useModal()

  const handleClose = useCallback(() => {
    modal.close()
  }, [modal])

  return (
    <>
      <Modal.Title>
        <Icon.Circle
          className="mb-4"
          intent="info"
          name="InformationCircleSolid"
        />
        {t(`msa.trade.success.heading`)}
      </Modal.Title>

      <Modal.Body>
        <p className="mt-6 text-neutral">
          <TransWithLink
            i18nKey="developer:msa.trade.success.description"
            variant="support"
          />
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button className="w-full" onClick={handleClose} variant="primary">
          {t`common:close`}
        </Button>
      </Modal.Footer>
    </>
  )
}
